import { useEffect } from 'react'

import { SITE } from '@/config/site'

function setMeta(selector: string, content: string) {
  document.head.querySelector<HTMLMetaElement>(selector)?.setAttribute('content', content)
}

/**
 * Per-route document title and description.
 *
 * A deliberately small stand-in for a full head manager — enough for a
 * multi-page marketing site, with no extra dependency. If the site later needs
 * server-rendered metadata, swap this for SSR or a prerender step.
 */
export function useDocumentMeta({ title, description }: { title: string; description?: string }) {
  useEffect(() => {
    document.title = `${title} — ${SITE.name}`
    if (description) {
      setMeta('meta[name="description"]', description)
      setMeta('meta[property="og:description"]', description)
    }
    setMeta('meta[property="og:title"]', `${title} — ${SITE.name}`)
  }, [title, description])
}
